/** @import FileItem from '@/classes/files/FileItem' */

/**
 * Acción para la representación di ficheros
 */
export default class Action {
  /** @type {function(FileItem): void} */ handler = file => {}
  /** @type {function(FileItem): boolean} */ show = file => true
  /** @type {String?} */ name = null
}
